/**
 * Settings Module
 */
import { sidebarFilters, routerAnimations, themes } from './data';

const state = {
  collapseSidebar: false, // mini sidevar
  horizontalLayoutSidebar: false, // horizontal layout sidebar
  sidebarFilters, // sidebar filters
  sidebarSelectedFilter: sidebarFilters[0], // selected sidebar filter
  routerAnimations, // router animations
  selectedRouterAnimation: routerAnimations[1], // selected router animation
  themes, // themes
  selectedTheme: themes[0], // selected theme
  isMobileSize: false
};

// getters
const getters = {
  collapseSidebar: (state) => {
    return state.collapseSidebar;
  },
  boxLayout: (state) => {
    return state.boxLayout;
  },
  sidebarFilters: (state) => {
    return state.sidebarFilters;
  },
  sidebarSelectedFilter: (state) => {
    return state.sidebarSelectedFilter;
  },
  selectedRouterAnimation: (state) => {
    return state.selectedRouterAnimation;
  },
  routerAnimations: (state) => {
    return state.routerAnimations;
  },
  themes: (state) => {
    return state.themes;
  },
  selectedTheme: (state) => {
    return state.selectedTheme;
  },
  horizontalLayoutSidebar: (state) => {
    return state.horizontalLayoutSidebar;
  },
  isMobileSize: (state) => {
    return state.isMobileSize;
  }
};

// mutations
const mutations = {
  setMiniSidebarLayoutHandler(state, isSet) {
    state.collapseSidebar = isSet;
  },
  toggleHorizontalLayoutSidebarHandler(state, value) {
    state.horizontalLayoutSidebar = value;
  },
  isMobileHandler(state, status) {
    state.isMobileSize = status;
  }
};

// actions
const actions = {
  setMiniSidebarLayout(context, payload) {
    context.commit('setMiniSidebarLayoutHandler', payload);
  },
  toggleHorizontalLayoutSidebar(context, payload) {
    context.commit('toggleHorizontalLayoutSidebarHandler', payload);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/settings/index.js